import { useState } from "react"
import { useSelector } from "react-redux"

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Grid
} from "@mui/material"
import Alert from "../main/Alert"
import {
    TicketContentStyles,
    TicketActionsStyles,
    TicketFieldsStyles
} from "./styles/TicketDialogStyles"
import { sendEmail } from "../../actions/emailActions"

export default function TicketDialog({
    open,
    handleClose,
    itmNumber,
    itmRevision,
    op,
    primary,
    setMainAlertDialog,
    setMainAlertSeverity,
    setMainAlertText
}) {
    const auth = useSelector((state) => state.auth)

    const [description, setDescription] = useState({
        value: "",
        error: false
    })

    const [alertDialog, setAlertDialog] = useState(false)
    const [alertSeverity, setAlertSeverity] = useState("success")
    const [alertText, setAlertText] = useState("")

    const [sendingEmail, setSendingEmail] = useState(false)

    const onSubmit = async () => {
        if (!description.value) {
            setDescription({
                value: description.value,
                error: true
            })
            setAlertText("Please enter a description")
            setAlertSeverity("error")
            setAlertDialog(true)
            return
        } else {
            let email = `<!DOCTYPE html>
            <html>
            
            <head>
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Century+Gothic:wght@400;700&display=swap');
            
                    body {
                        font-family: 'Century Gothic', sans-serif;
                        color: #333333;
                    }
            
                    /* Add a class to style the description section */
                    .description {
                        margin-left: 20px; /* Adjust the desired indentation value */
                    }
                </style>
            </head>
            
            <body>
                <div class="email-content">
                    <p>Hello Team,</p>
                    <p>We need your assistance with the Inspection Report for Item ${itmNumber} Revision ${itmRevision} Operation ${op} - ${
                primary ? "Primary" : "Alternate"
            }.</p>
            
                    
                    <p><b>Issue Description:</b></p>
                    <code class="description">${description.value}</code>
            
                    <p>Best,</p>
                    <p>${auth.user.displayName} (${auth.user.email})</p>
                </div>
            </body>
            
            </html>`
            const emails = "servicedesk@precipart.com"
            const emailInfoObject = {
                emailList: emails,
                emailSubject: `Support Request: Inspection Report for Item ${itmNumber} Rev. ${itmRevision} Operation ${op} ${
                    primary ? "Primary" : "Alternate"
                }`,
                emailContent: email
            }
            try {
                setSendingEmail(true)
                await sendEmail(emailInfoObject)
                setMainAlertSeverity("success")
                setMainAlertDialog(true)
                setMainAlertText("Ticket sent successfully")
            } catch (error) {
                setAlertSeverity("error")
                setAlertDialog(true)
                setAlertText("Error sending ticket")
                console.log(error)
            }
            clearStates()
            setSendingEmail(false)
            handleClose()
        }
    }

    const handleDescriptionChange = (e) => {
        setDescription({
            value: e.target.value,
            error: false
        })
    }

    const closeDialog = () => {
        clearStates()
        handleClose()
    }

    //close alerts
    const handleAlertDialogClose = (event, reason) => {
        if (reason === "clickaway") {
            return
        }
        setAlertDialog(false)
        setAlertText("")
    }

    //clear all states
    const clearStates = () => {
        setDescription({
            value: "",
            error: false
        })
        setSendingEmail(false)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            aria-labelledby="ticket-dialog-title"
        >
            <DialogTitle id="ticket-dialog-title">Ticket Details</DialogTitle>
            <DialogContent sx={TicketContentStyles}>
                <Grid container spacing={2} sx={TicketFieldsStyles}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label="Item Number"
                            value={itmNumber ?? ""}
                            fullWidth
                            slotProps={{ input: { readOnly: true } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3 }}>
                        <TextField
                            label="Item Revision"
                            value={itmRevision ?? ""}
                            fullWidth
                            slotProps={{ input: { readOnly: true } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3 }}>
                        <TextField
                            label="Operation"
                            value={op ?? ""}
                            fullWidth
                            slotProps={{ input: { readOnly: true } }}
                        />
                    </Grid>
                    <Grid size={12}>
                        <TextField
                            label="Description"
                            multiline
                            required
                            fullWidth
                            variant="outlined"
                            onChange={handleDescriptionChange}
                            error={description.error}
                            helperText={description.error ? "Please enter a description" : undefined}
                            value={description.value}
                            rows={4}
                        />
                    </Grid>
                    {description.error && alertDialog && (
                        <Grid size={12}>
                            <Alert
                                onClose={handleAlertDialogClose}
                                severity={alertSeverity}
                            >
                                {alertText}
                            </Alert>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions sx={TicketActionsStyles}>
                <Button
                    onClick={onSubmit}
                    color="primary"
                    disabled={sendingEmail}
                >
                    {sendingEmail ? "Sending..." : "Submit"}
                </Button>
                <Button
                    onClick={closeDialog}
                    color="primary"
                    disabled={sendingEmail}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}
